var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("开票信息")]),
      ]),
      _c(
        "el-descriptions",
        { attrs: { column: 2, border: "" } },
        [
          _c("el-descriptions-item", { attrs: { label: "开票类型" } }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.getInvoiceTypeName(_vm.invoiceData.invoiceType)) +
                "\n\t\t"
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "开票金额" } }, [
            _vm._v(_vm._s(_vm.invoiceData.money) + "元"),
          ]),
          !_vm.isMore
            ? _c("el-descriptions-item", { attrs: { label: _vm.setTitle } }, [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.identification) + "\n\t\t"
                ),
              ])
            : _vm._e(),
          !_vm.isMore
            ? _c("el-descriptions-item", { attrs: { label: "发票抬头" } }, [
                _vm._v("\n\t\t\t" + _vm._s(_vm.invoiceData.title) + "\n\t\t"),
              ])
            : _vm._e(),
          _vm.invoiceData.invoiceType === "1" && _vm.invoiceData.bankName
            ? [
                _c("el-descriptions-item", { attrs: { label: "注册地址" } }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.invoiceData.address) + "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "注册电话" } }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.invoiceData.phone) + "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "开户银行" } }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.invoiceData.bankName) + "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "开户账号" } }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.invoiceData.bankNo) + "\n\t\t\t"
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.invoiceData.invoiceType === "1" && _vm.invoiceData.mailName
            ? [
                _c("el-descriptions-item", { attrs: { label: "收件人" } }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.invoiceData.mailName) + "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.invoiceData.mailPhone) +
                      "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "收件人地址" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.invoiceData.mailAreaName) +
                      "\n\t\t\t"
                  ),
                ]),
                _c("el-descriptions-item", { attrs: { label: "详细地址" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.invoiceData.mailAddress) +
                      "\n\t\t\t"
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }